export default __webpack_public_path__ + "static/media/profile_inactive.046923a6.svg";